import React from 'react';
import { useNavigate } from 'react-router-dom';

export const CustomerRegisterStep1 = ({ goToStep2 }) => {
  const navigate = useNavigate();

  return (
    <div className="register-area">
      <div className="register-area__intro-title">
        어떤 서비스를<br/>이용하고 싶으세요?
      </div>
      <div className="register-area__intro-description">
        원하는 회원가입 유형을 선택하세요
      </div>

      <div className="register-area__intro-user-text">
        관광하고 싶은 일반인이라면?
      </div>

      <div className="register-area__intro-user-btn-block" onClick={goToStep2}>
        <img 
          className="register-area__intro-user-btn-icon" 
          src="/icons/icon_check.svg" 
          alt="체크 아이콘"
        />
        <div className="register-area__intro-user-btn-text">
          일반으로 가입
        </div>
      </div>

      <div className="register-area__intro-artist-text">
        아뜰리에 투어를 판매하고 싶은 작가라면?
      </div>

      <div 
        className="register-area__intro-artist-btn-block" 
        onClick={() => navigate('/artist-register')}
      >
        <img 
          className="register-area__intro-artist-btn-icon" 
          src="/icons/icon_check.svg" 
          alt="체크 아이콘"
        />
        <div className="register-area__intro-artist-btn-text">
          작가로 가입 (아트로그 연동)
        </div>
      </div>
    </div>
  );
};